// extracted by mini-css-extract-plugin
export var activeDot = "_3b-c";
export var buttonContainer = "_3b-9";
export var channelButton = "_3b-a";
export var clickable = "_3b-d";
export var content = "_3b-0";
export var contentFull = "_3b-2";
export var contentThird = "_3b-1";
export var contentWrapper = "_3b-7";
export var description = "_3b-5";
export var heightShort = "_3b-f";
export var image = "_3b-3";
export var imageContainer = "_3b-4";
export var selectButton = "_3b-e";
export var spinnerContainer = "_3b-b";
export var titleContent = "_3b-8";
export var titleWrapper = "_3b-6";